<template>
  <div class="home">
    <div v-if="isLoadingData">
        <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_nvskuoaw.json"  background="transparent" class="customProgress"  speed="1"  style="width: 300px; height: 300px;"    autoplay></lottie-player>
    </div>
    <div v-else>
        <Toast /> 
        <Header :headerData = "headerData" />
        <InformationStudents :informationsData = "informationsData" title="I. THÔNG TIN HỌC SINH"/>
        <SummaryLearning :summaryLearning="summaryLearning" title="II. TỔNG KẾT HỌC TẬP (Báo cáo nhanh đến thời điểm hiện tại)"/>
        <TableSchoolFees :tableSchoolFeesData="tableSchoolFeesData" :unpaidSchoolFeeData="unpaidSchoolFeeData" title="III. CHUYÊN CẦN VÀ HỌC PHÍ"/>
        <ResultLearning :resultLearningData="resultLearningData" title="IV. KẾT QUẢ HỌC TẬP"/>
        <ResultSummary :resultSummaryData="resultSummaryData" title="V. KẾT QUẢ TỔNG HỢP" />
        <TeacherComments :teacherCommentsData = "teacherCommentsData" title="VI. NHẬN XÉT CỦA GIÁO VIÊN"/>
        <footer>Một sản phẩm của MEGAEDU</footer>
    </div>
    <Dialog header="Thông báo" :visible="displayModal" :modal="true" :closable="false" :breakpoints="{'960px': '75vw'}" :style="{width: '50vw'}">
        <h4>{{errText}}</h4>
        <Button label="Quay lại" icon="pi pi-arrow-left" @click="backToPage()"/>
    </Dialog>   
  </div>
</template>

<script>
import Header from './Header.vue'
import InformationStudents from './InformationStudents.vue'
import SummaryLearning from './SummaryLearning.vue'
import TableSchoolFees from './TableSchoolFees.vue'
import ResultLearning from './ResultLearning.vue'
import ResultSummary from './ResultSummary.vue'
import TeacherComments from './TeacherComments.vue'

export default {
  name: 'Homepage',
  components: {
      Header, 
      InformationStudents, 
      TableSchoolFees, 
      ResultLearning, 
      ResultSummary, 
      TeacherComments, 
      SummaryLearning
    },
  data() {
    return {
        dataSet:'',
      headerData: {
          centerNameClass:'',
          codeClass: '',
          calendarLearning:'',
          teacherName:'',
          logo:''
      },
      informationsData: {
          studentName:'',
          classAtSchool:'',
          studentPhone:'',
          parentPhone:'',
          parentName:'',
          studentCode:'',
          studentBirth:'',
          code:'',
          schoolName:'',
          studentPicture:''
      },
      summaryLearning: {
          averageMark:null,
          diligentMark:null,
          totalMark:null,
          rank:null
      },
      tableSchoolFeesData:null,
      unpaidSchoolFeeData: '',
      resultLearningData:[],
      resultSummaryData:[],
      teacherCommentsData:[],
      isLoadingData: false,
      displayModal:false,
      errText: '',
        valueProgress: 0,
    }
  },
  watch: {
  },
  created() {
    this.getData()
  },
  methods: {
    getData(){
        this.startProgress();
        let route = this.$route.params
        this.isLoadingData = true
        // toast is loading data
        this.$toast.add({
              severity:'info', 
              summary: 'Message', 
              detail:'Dữ liệu đang được tải', life: 3000
            })
        // Get router
        // let cName = 'Giáo dục Minh Trí'
        // let name = 'Nguyễn Ngọc Phương Uyên'
        // let pho = '0983120670'
        // pass data to bodyForm
         // let bodyFormData = {
        //     mode:'phieulienlac',
        //     hoTen: name != null ? name : '',
        //     centerName:cName != null ? cName : '',
        //     dienThoai: pho != null ? pho : '',
        // }
        let bodyFormData = {
            mode:'phieulienlac',
            hoTen: route.name != null ? route.name : '',
            centerName:route.centerName != null ? route.centerName : 'Trung tâm Lý Hoàng Lê',
            dienThoai: route.phone != null ? route.phone : '',
            subject: route.subject != null ? route.subject : '',
            // ngaySinh: route.date != null ? this.formatDate(route.date) : ''
        }
       
        let self = this
        self.axios({
          method: "post",
          url: self.$urlAPI,
          data: JSON.stringify(bodyFormData),
          headers: {
              'Content-Type':'application/json'
          },
          auth: this.$auth,
        })
        .then(response => {
          if (response.data.status === false) {
                self.displayModal = true
                self.errText = response.data.reason
          } else {
              self.$toast.add({
              severity:'success', 
              summary: 'Message', 
              detail:'Loading data has success', life: 3000
            })
            self.dataSet = response.data
            let data = response.data.data
            if (data != '') {
                self.makeHeader(data)
                self.makeInformationStudents(data)
                self.makeSummaryLearning(data)
                self.makeTableSchoolFees(data)
                self.makeResultLearning(data)
                self.makeresultSummaryData(data)
                self.makeTeacherComments(data)
            }
          }
        }).catch(err => 
            {
              self.$toast.add({
                  severity:'error', 
                  summary: 'Error Message', 
                  detail:'Err' + err, life: 3000
              })
            }
        ).finally(() => {
            self.isLoadingData = false
            self.endProgress();
        })
    },
    makeHeader(data){
        // let arrTeacherName = data['Giáo viên'] !='' ? data['Giáo viên'] : [];
        // let nameConcate = [];
        // if(arrTeacherName.length > 0) {
        //     for (let index = 0; index < arrTeacherName.length; index++) {
        //         const element = arrTeacherName[index];
        //         nameConcate.push(element['Họ và tên'])
        //     }
        // }
        this.headerData = {
            centerName:data['Trung tâm'] !='' ? data['Trung tâm'] : '',
            centerNameClass:data['Lớp ở trung tâm'] !='' ? data['Lớp ở trung tâm'] : '',
            codeClass: data['Mã lớp'] !='' ? data['Mã lớp'] : '',
            calendarLearning:data['Lịch học'] !='' ? data['Lịch học'] : '',
            teacherName:data['Giáo viên'] !='' ? data['Giáo viên'] : '[]',
            logo:data['Logo'] !='' ? data['Logo'] : ''
        }
    },
    makeInformationStudents(data){
        this.informationsData = {
          studentName: data['Họ và tên'] !='' ? data['Họ và tên'] : '',
          classAtSchool: data['Lớp ở trường'] !='' ? data['Lớp ở trường'] : '',
          studentPhone: data['Điện thoại'] !='' ? data['Điện thoại'] : '',
          parentPhone: data['Điện thoại phụ huynh'] !='' ? data['Điện thoại phụ huynh'] : '',
          parentName: data['Tên phụ huynh'] !='' ? data['Tên phụ huynh'] : '',
          studentCode: data['Mã học viên'] !='' ? data['Mã học viên'] : '',
          studentBirth: data['Ngày sinh'] !='' ? data['Ngày sinh'] : '',
          code: data['SBD'] !='' ? data['SBD'] : '',
          schoolName: data['Trường'] !='' ? data['Trường'] : '',
          studentPicture: data['Ảnh hồ sơ'] !='' ? data['Ảnh hồ sơ'] : ''
      }
    },
    makeSummaryLearning(data){
        this.summaryLearning = {
          averageMark:data['Điểm trung bình'] !='' ? data['Điểm trung bình'] : '',
          diligentMark:data['Điểm chuyên cần'] !='' ? data['Điểm chuyên cần'] : '',
          totalMark:data['Điểm tổng kết'] !='' ? data['Điểm tổng kết'] : '',
          rank: data['Xếp hạng'] !='' ? data['Xếp hạng'] : ''
      }
    },
    makeTableSchoolFees(data){
        this.tableSchoolFeesData = data['Điểm danh'] !='' ? data['Điểm danh'] : ''
        this.unpaidSchoolFeeData = data['Học phí chưa đóng (Tháng)'] != '' ? data['Học phí chưa đóng (Tháng)'] : '';
    },
    makeResultLearning(data){
        let course1 = data['Kết quả HKI'] !='' ? data['Kết quả HKI'] : ''
        let course2 = data['Kết quả HKII'] !='' ? data['Kết quả HKII'] : ''
        this.resultLearningData.push(course1)
        this.resultLearningData.push(course2)
    },
    makeresultSummaryData(data){
        this.resultSummaryData = data['Kết quả tổng hợp'] !='' ? data['Kết quả tổng hợp'] : ''
    },
    makeTeacherComments(data){
        this.teacherCommentsData = data['Nhận xét'] !='' ? data['Nhận xét'] : ''
    },
    formatDate(dateString){
        let date = new Date(dateString).toLocaleString({timeZone: 'Asia/Ho_Chi_Minh'});
        const replaceWith = '-';
        const search = '/';

        let dateSplit = date.split(' ');
        let newDate = dateSplit[0].split(search).join(replaceWith)
        return newDate
    }, 
    backToPage(){
        this.$router.go(-1)
    },
    startProgress() {
        this.interval = setInterval(() => {
            let newValue = this.valueProgress + Math.floor(Math.random() * 10) + 1;
            if (newValue >= 100) {
                newValue = 100;
            }
            this.valueProgress = newValue;
        }, 2000);
    },
    endProgress() {
        clearInterval(this.interval);
        this.interval = null;
    }
  }
}
</script>

<style>
body{
    padding: 0;
    margin: 0;
}

.customProgress{
    position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.flex-container {
    display: flex;
    flex-wrap: wrap;
  }
.logo img{
    max-width: 55%;
}
.name,
.title{
    margin-top:0;
    margin-bottom:0;
    text-align: center;
}
.name{
    background-color: #FFE599;
}
.background-sort-blue-color{
    background-color: #B7E2CD;
}
.background-blue-color{
    background-color: #CFE2F3;
}
.color-blue{
    color: #415C8E;
}
.background-pink-color{
    background-color: #FCE9D9;
}
.background-red-color{
    background-color: #FD0000;
}
.color-yeallow{
    color: #EAEB03;
}
.background-yeallow-color{
    background-color: #EAEB03;
}
.color-red{
    color: #FD0000;
}
header .box{
    display: flex;
    flex-wrap: wrap;
    margin-right: 15px;
    margin-left: 15px;
}
header .box .item{
    display: flex;
    align-items: baseline;
}
header .box .item label{
    flex: 30%;
    text-align: right;
}
header .box .item h3{
    flex: 70%;
    padding-left: 15px;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    text-align: left;
}

/* information-student */
.title-section {
    padding-left: 15px;
    background-color: #EAF1DD;
    color: #FF0000;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: left;
    margin-bottom: 0px;
}
.information-student .box{
    display: flex;
    /* padding-left: 10%; */
    margin-left: 15px;
    margin-right: 15px;
}
.information-student .box .picture img{
    margin-top: 5px;
    width: 100%;
}
.information-student .box .item{
    display: flex;
    align-items: baseline;
}
.information-student .box .picture img{
    margin-top: 5px;
    width: 100%;
}
.information-student .box .item label{
    flex: 40%;
    text-align: right;
}
.information-student .box .item h3{
    flex: 60%;
    padding-left: 5px;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    text-align: left;
}


/* Table */
.table-school-fees{
    overflow: scroll;
    position: relative;
    width: 100%;
    display: block;
}
.table-school-fees table{
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    overflow: scroll;
    margin-bottom: 10px;
    min-width: 600px;
    table-layout: fixed;
  }
  
.table-school-fees table td, 
.table-school-fees table th {
    border: 3px solid #000;
    /* text-align: left; */
    /* padding: 5px; */
    /* width: 50px; */
}
.table-school-fees table td{
    width: 50px;
}
.table-school-fees .title-section{
    min-width: 600px;
}
/* Section  result-learning*/
.result-learning .box{
    overflow: auto;
}
.result-learning .box table{
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  
.result-learning .box table td,
.result-learning .box table th {
    border: 3px solid #000;
    text-align: center;
    padding: 5px;
}
/* Section result-summary  */
.result-summary .box-diagram{
    min-width: 500px
}
.result-summary .box-content .box-table table{
    font-family: arial, sans-serif;
    height: 100%;
    width: 100%;
    border-collapse: collapse;
}
.result-summary .box-content .box-table table td,
.result-summary .box-content .box-table table th {
    border: 3px solid #000;
    text-align: center;
    padding: 5px;
}

/* teacher-comments */
.teacher-comments table{
    width: 100%;
    font-family: arial, sans-serif;
    border-collapse: collapse;
}
.teacher-comments table td,
.teacher-comments table th {
    border: 3px solid #000;
    text-align: center;
    padding: 5px;
}
/* Code footer */
footer{
    margin-top: 50px;
    background: teal;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
}

/* Code responive page */
@media only screen and (max-width : 400px) {
/* Styles */
    .logo img{
        max-width: 40%;
        margin: 0 auto;
    }
    .result-summary .box-diagram{
        min-width: 650px;
    }
}
@media only screen and (max-width : 575px) {
    .logo img{
        max-width: 35%;
        margin: 0 auto;
    }
    .information-student .box .picture img{
        width: 30%;
        margin: 0 auto;
    }
}
@media only screen and (min-width : 576px) {
    .logo img{
        max-width: 70%;
    }

}
</style>